export default __webpack_public_path__ + "static/media/lungs_img_0004_Talk_To_Someone.faf73909.png";